/* eslint-disable react/require-default-props */
import React from 'react';
import { translate } from '@utils/i18n';
import { FireIconWhite } from '@icons/FireIcon';
import './RunAiButtonStyles.scss';
const namespace = 'whats_new_modal';
export default function RunAiButton({ onClick, disabled = false, isLoading = false }) {
    return (React.createElement("button", { type: "button", className: `run-ai-button ${disabled ? 'run-ai-button--disabled' : ''} ${isLoading ? 'run-ai-button--loading' : ''}`, onClick: onClick, disabled: disabled || isLoading },
        !isLoading && (React.createElement("div", { className: "run-ai-button__icon" },
            React.createElement(FireIconWhite, null))),
        isLoading && (React.createElement("div", { className: "run-ai-button__spinner" },
            React.createElement("div", { className: "spinner" }))),
        React.createElement("span", { className: "run-ai-button__text" }, isLoading ? translate('running', { namespace }) : translate('run_inspection_assistant', { namespace }))));
}
